// extracted by mini-css-extract-plugin
module.exports = {"container":"svgicon_container__6m_D8","dark":"svgicon_dark__6ChEx","light":"svgicon_light__7y210"};